<template>
    <div class="container">
        <h1>Logar</h1>


        <b-card no-body>
        <b-tabs pills card vertical>
            <b-tab title="Login" active>
                <LoginForm  @logged="redirect"/>
            </b-tab>
            <b-tab title="Registre-se">
              <RegisterForm  @logged="redirect"/>
            </b-tab>
            <!-- <b-tab title="Esqueceu sua senha?"> -->
              <!-- <ForgetPasswordForm @logged="redirect"/> -->
            <!-- </b-tab> -->
        </b-tabs>
        </b-card>


        
    </div>
</template>

<script>

import validadeFormMixins from "@/mixins/validateForms"
import api from "@/api"

export default {
    mixins:[validadeFormMixins],

    data(){
        return{
            clientInfo:{},
            error:false,
            edit:false,
            registerAnother:false,
            erromsg:'',
            mode:"login"
        }
    },

    created:{
    
    },
    
    computed:{
        user:function(){
            return this.$store.getters.user
        }
    },

    methods:{

        redirect:function(){
            let path = this.$route.query.redirect;
            if(!path) path="/";
            this.$router.replace(path);
        }
        
    }

}
</script>